import type { IconName } from "metabase-types/api";

import one_million_component from "./1m.svg?component";
import ten_thousand_component from "./10k.svg?component";
import add_component from "./add.svg?component";
import add_collection_component from "./add_collection.svg?component";
import add_column_component from "./add_column.svg?component";
import add_comment_component from "./add_comment.svg?component";
import add_data_component from "./add_data.svg?component";
import add_folder_component from "./add_folder.svg?component";
import add_list_component from "./add_list.svg?component";
import add_row_component from "./add_row.svg?component";
import add_to_dash_component from "./add_to_dash.svg?component";
import ai_component from "./ai.svg?component";
import alert_component from "./alert.svg?component";
import alert_confirm_component from "./alert_confirm.svg?component";
import alert_filled_component from "./alert_filled.svg?component";
import app_component from "./app.svg?component";
import archive_component from "./archive.svg?component";
import area_component from "./area.svg?component";
import arrow_down_component from "./arrow_down.svg?component";
import arrow_left_component from "./arrow_left.svg?component";
import arrow_left_to_line_component from "./arrow_left_to_line.svg?component";
import arrow_right_component from "./arrow_right.svg?component";
import arrow_split_component from "./arrow_split.svg?component";
import arrow_up_component from "./arrow_up.svg?component";
import attachment_component from "./attachment.svg?component";
import audit_component from "./audit.svg?component";
import badge_component from "./badge.svg?component";
import ban_component from "./ban.svg?component";
import bar_component from "./bar.svg?component";
import bell_component from "./bell.svg?component";
import bell_12_component from "./bell_12.svg?component";
import birthday_component from "./birthday.svg?component";
import bolt_component from "./bolt.svg?component";
import bolt_filled_component from "./bolt_filled.svg?component";
import book_open_component from "./book_open.svg?component";
import bookmark_component from "./bookmark.svg?component";
import bookmark_filled_component from "./bookmark_filled.svg?component";
import boxplot_component from "./boxplot.svg?component";
import breakout_component from "./breakout.svg?component";
import broken_link_component from "./broken_link.svg?component";
import bubble_component from "./bubble.svg?component";
import bug_component from "./bug.svg?component";
import burger_component from "./burger.svg?component";
import cake_component from "./cake.svg?component";
import calendar_component from "./calendar.svg?component";
import camera_component from "./camera.svg?component";
import chart_layout_default_component from "./chart_layout_default.svg?component";
import chart_layout_stack_component from "./chart_layout_stack.svg?component";
import check_component from "./check.svg?component";
import check_filled_component from "./check_filled.svg?component";
import chevrondown_component from "./chevrondown.svg?component";
import chevronleft_component from "./chevronleft.svg?component";
import chevronright_component from "./chevronright.svg?component";
import chevronup_component from "./chevronup.svg?component";
import click_component from "./click.svg?component";
import clipboard_component from "./clipboard.svg?component";
import clock_component from "./clock.svg?component";
import clone_component from "./clone.svg?component";
import close_component from "./close.svg?component";
import cloud_component from "./cloud.svg?component";
import cloud_12_component from "./cloud_12.svg?component";
import cloud_filled_component from "./cloud_filled.svg?component";
import code_block_component from "./code_block.svg?component";
import collection2_component from "./collection2.svg?component";
import combine_component from "./combine.svg?component";
import comment_component from "./comment.svg?component";
import company_component from "./company.svg?component";
import compare_component from "./compare.svg?component";
import connections_component from "./connections.svg?component";
import contract_component from "./contract.svg?component";
import copy_component from "./copy.svg?component";
import corner_down_right_component from "./corner_down_right.svg?component";
import corner_up_right_component from "./corner_up_right.svg?component";
import currency_component from "./currency.svg?component";
import curve_component from "./curve.svg?component";
import curved_component from "./curved.svg?component";
import dash_component from "./dash.svg?component";
import dashboard_component from "./dashboard.svg?component";
import data_studio_component from "./data_studio.svg?component";
import database_component from "./database.svg?component";
import database_routing_component from "./database_routing.svg?component";
import dependencies_component from "./dependencies.svg?component";
import dependent_component from "./dependent.svg?component";
import document_component from "./document.svg?component";
import download_component from "./download.svg?component";
import dyno_component from "./dyno.svg?component";
import edit_document_component from "./edit_document.svg?component";
import edit_document_outlined_component from "./edit_document_outlined.svg?component";
import ellipsis_component from "./ellipsis.svg?component";
import embed_component from "./embed.svg?component";
import embed_interactive_component from "./embed_interactive.svg?component";
import embed_modular_component from "./embed_modular.svg?component";
import embed_static_component from "./embed_static.svg?component";
import empty_component from "./empty.svg?component";
import enter_or_return_component from "./enter_or_return.svg?component";
import event_component from "./event.svg?component";
import exit_component from "./exit.svg?component";
import expand_component from "./expand.svg?component";
import expand_arrow_component from "./expand_arrow.svg?component";
import extract_component from "./extract.svg?component";
import eye_component from "./eye.svg?component";
import eye_crossed_out_component from "./eye_crossed_out.svg?component";
import eye_outline_component from "./eye_outline.svg?component";
import factory_component from "./factory.svg?component";
import field_component from "./field.svg?component";
import fields_component from "./fields.svg?component";
import filter_component from "./filter.svg?component";
import filter_plus_component from "./filter_plus.svg?component";
import find_replace_component from "./find_replace.svg?component";
import folder_component from "./folder.svg?component";
import folder_database_component from "./folder_database.svg?component";
import folder_filled_component from "./folder_filled.svg?component";
import format_code_component from "./format_code.svg?component";
import formula_component from "./formula.svg?component";
import function_component from "./function.svg?component";
import funnel_component from "./funnel.svg?component";
import funnel_outline_component from "./funnel_outline.svg?component";
import gauge_component from "./gauge.svg?component";
import gear_component from "./gear.svg?component";
import gear_settings_filled_component from "./gear_settings_filled.svg?component";
import gem_component from "./gem.svg?component";
import ghost_component from "./ghost.svg?component";
import git_branch_component from "./git_branch.svg?component";
import globe_component from "./globe.svg?component";
import glossary_component from "./glossary.svg?component";
import google_component from "./google.svg?component";
import google_drive_component from "./google_drive.svg?component";
import google_sheet_component from "./google_sheet.svg?component";
import grabber_component from "./grabber.svg?component";
import grid_component from "./grid.svg?component";
import grid_2x2_component from "./grid_2x2.svg?component";
import grid_bordered_component from "./grid_bordered.svg?component";
import group_component from "./group.svg?component";
import history_component from "./history.svg?component";
import home_component from "./home.svg?component";
import horizontal_bar_component from "./horizontal_bar.svg?component";
import hourglass_component from "./hourglass.svg?component";
import index_component from "./index.svg?component";
import info_component from "./info.svg?component";
import info_outline_component from "./info_outline.svg?component";
import insight_component from "./insight.svg?component";
import int_component from "./int.svg?component";
import io_component from "./io.svg?component";
import join_full_outer_component from "./join_full_outer.svg?component";
import join_inner_component from "./join_inner.svg?component";
import join_left_outer_component from "./join_left_outer.svg?component";
import join_right_outer_component from "./join_right_outer.svg?component";
import key_component from "./key.svg?component";
import label_component from "./label.svg?component";
import layout_grid_component from "./layout_grid.svg?component";
import ldap_component from "./ldap.svg?component";
import learn_component from "./learn.svg?component";
import lightbulb_component from "./lightbulb.svg?component";
import line_component from "./line.svg?component";
import line_style_dashed_component from "./line_style-dashed.svg?component";
import line_style_dotted_component from "./line_style-dotted.svg?component";
import line_style_solid_component from "./line_style-solid.svg?component";
import lineandbar_component from "./lineandbar.svg?component";
import lines_component from "./lines.svg?component";
import link_component from "./link.svg?component";
import list_component from "./list.svg?component";
import location_component from "./location.svg?component";
import lock_component from "./lock.svg?component";
import lock_filled_component from "./lock_filled.svg?component";
import mail_component from "./mail.svg?component";
import mail_at_component from "./mail_at.svg?component";
import mail_filled_component from "./mail_filled.svg?component";
import map_component from "./map.svg?component";
import mcp_component from "./mcp.svg?component";
import medallion_component from "./medallion.svg?component";
import message_circle_component from "./message_circle.svg?component";
import metabot_component from "./metabot.svg?component";
import metabot_sad_component from "./metabot_sad.svg?component";
import metric_component from "./metric.svg?component";
import mode_component from "./mode.svg?component";
import model_component from "./model.svg?component";
import model_with_badge_component from "./model_with_badge.svg?component";
import moon_component from "./moon.svg?component";
import move_component from "./move.svg?component";
import move_card_component from "./move_card.svg?component";
import network_component from "./network.svg?component";
import new_folder_component from "./new_folder.svg?component";
import note_component from "./note.svg?component";
import note_12_component from "./note_12.svg?component";
import notebook_component from "./notebook.svg?component";
import number_component from "./number.svg?component";
import octagon_alert_component from "./octagon_alert.svg?component";
import official_collection_component from "./official_collection.svg?component";
import open_folder_component from "./open_folder.svg?component";
import ordered_list_component from "./ordered_list.svg?component";
import package_component from "./package.svg?component";
import palette_component from "./palette.svg?component";
import pause_component from "./pause.svg?component";
import pencil_component from "./pencil.svg?component";
import pencil_lines_component from "./pencil_lines.svg?component";
import permissions_limited_component from "./permissions_limited.svg?component";
import person_component from "./person.svg?component";
import pie_component from "./pie.svg?component";
import pie_slice_component from "./pie_slice.svg?component";
import pin_component from "./pin.svg?component";
import pinmap_component from "./pinmap.svg?component";
import pivot_table_component from "./pivot_table.svg?component";
import play_component from "./play.svg?component";
import play_outlined_component from "./play_outlined.svg?component";
import popover_component from "./popover.svg?component";
import popular_component from "./popular.svg?component";
import progress_component from "./progress.svg?component";
import publish_component from "./publish.svg?component";
import published_component from "./published.svg?component";
import pulse_component from "./pulse.svg?component";
import question_component from "./question.svg?component";
import quote_component from "./quote.svg?component";
import receipt_component from "./receipt.svg?component";
import recents_component from "./recents.svg?component";
import redo_component from "./redo.svg?component";
import reference_component from "./reference.svg?component";
import refresh_component from "./refresh.svg?component";
import refresh_downstream_component from "./refresh_downstream.svg?component";
import rename_component from "./rename.svg?component";
import repository_component from "./repository.svg?component";
import return_component from "./return.svg?component";
import revert_component from "./revert.svg?component";
import rocket_component from "./rocket.svg?component";
import ruler_component from "./ruler.svg?component";
import sankey_component from "./sankey.svg?component";
import schema_component from "./schema.svg?component";
import search_component from "./search.svg?component";
import search_check_component from "./search_check.svg?component";
import section_component from "./section.svg?component";
import segment_component from "./segment.svg?component";
import send_component from "./send.svg?component";
import settings_component from "./settings.svg?component";
import share_component from "./share.svg?component";
import shield_component from "./shield.svg?component";
import shield_outline_component from "./shield_outline.svg?component";
import shield_stroke_component from "./shield_stroke.svg?component";
import sidebar_closed_component from "./sidebar_closed.svg?component";
import sidebar_open_component from "./sidebar_open.svg?component";
import slack_component from "./slack.svg?component";
import slack_colorized_component from "./slack_colorized.svg?component";
import sliders_component from "./sliders.svg?component";
import smartscalar_component from "./smartscalar.svg?component";
import smile_component from "./smile.svg?component";
import snail_component from "./snail.svg?component";
import snippet_component from "./snippet.svg?component";
import sort_component from "./sort.svg?component";
import sort_arrows_component from "./sort_arrows.svg?component";
import sparkles_component from "./sparkles.svg?component";
import split_component from "./split.svg?component";
import sql_component from "./sql.svg?component";
import star_component from "./star.svg?component";
import star_filled_component from "./star_filled.svg?component";
import stepped_component from "./stepped.svg?component";
import sticky_note_component from "./sticky-note.svg?component";
import stop_component from "./stop.svg?component";
import store_component from "./store.svg?component";
import straight_component from "./straight.svg?component";
import string_component from "./string.svg?component";
import subscription_component from "./subscription.svg?component";
import sum_component from "./sum.svg?component";
import sun_component from "./sun.svg?component";
import sync_component from "./sync.svg?component";
import synced_collection_component from "./synced_collection.svg?component";
import t_shirt_component from "./t-shirt.svg?component";
import tab_component from "./tab.svg?component";
import table_component from "./table.svg?component";
import table2_component from "./table2.svg?component";
import table_index_component from "./table_index.svg?component";
import telescope_component from "./telescope.svg?component";
import test_tube_component from "./test_tube.svg?component";
import text_bold_component from "./text_bold.svg?component";
import text_italic_component from "./text_italic.svg?component";
import text_strike_component from "./text_strike.svg?component";
import thumbs_down_component from "./thumbs_down.svg?component";
import thumbs_up_component from "./thumbs_up.svg?component";
import time_history_component from "./time_history.svg?component";
import transform_component from "./transform.svg?component";
import trash_component from "./trash.svg?component";
import trash_filled_component from "./trash_filled.svg?component";
import treemap_component from "./treemap.svg?component";
import trend_down_component from "./trend_down.svg?component";
import trend_flat_component from "./trend_flat.svg?component";
import trend_up_component from "./trend_up.svg?component";
import triangle_left_component from "./triangle_left.svg?component";
import triangle_right_component from "./triangle_right.svg?component";
import unarchive_component from "./unarchive.svg?component";
import undo_component from "./undo.svg?component";
import unknown_component from "./unknown.svg?component";
import unpin_component from "./unpin.svg?component";
import unpublish_component from "./unpublish.svg?component";
import unreferenced_component from "./unreferenced.svg?component";
import unsubscribe_component from "./unsubscribe.svg?component";
import upload_component from "./upload.svg?component";
import variable_component from "./variable.svg?component";
import verified_component from "./verified.svg?component";
import verified_filled_component from "./verified_filled.svg?component";
import verified_round_component from "./verified_round.svg?component";
import view_archive_component from "./view_archive.svg?component";
import warning_component from "./warning.svg?component";
import warning_round_component from "./warning_round.svg?component";
import warning_round_filled_component from "./warning_round_filled.svg?component";
import warning_triangle_filled_component from "./warning_triangle_filled.svg?component";
import waterfall_component from "./waterfall.svg?component";
import webhook_component from "./webhook.svg?component";
import zap_component from "./zap.svg?component";
import zoom_in_component from "./zoom_in.svg?component";
import zoom_out_component from "./zoom_out.svg?component";

export const Icons: Record<IconName, React.VFC> = {
  add: add_component,
  add_collection: add_collection_component,
  add_column: add_column_component,
  add_data: add_data_component,
  add_folder: add_folder_component,
  add_list: add_list_component,
  add_row: add_row_component,
  add_to_dash: add_to_dash_component,
  add_comment: add_comment_component,
  ai: ai_component,
  alert: alert_component,
  alert_filled: alert_filled_component,
  alert_confirm: alert_confirm_component,
  app: app_component,
  archive: archive_component,
  area: area_component,
  attachment: attachment_component,
  arrow_up: arrow_up_component,
  arrow_down: arrow_down_component,
  arrow_left: arrow_left_component,
  arrow_left_to_line: arrow_left_to_line_component,
  arrow_right: arrow_right_component,
  arrow_split: arrow_split_component,
  audit: audit_component,
  badge: badge_component,
  ban: ban_component,
  bar: bar_component,
  bell: bell_component,
  bell_12: bell_12_component,
  birthday: birthday_component,
  bookmark: bookmark_component,
  bookmark_filled: bookmark_filled_component,
  book_open: book_open_component,
  bolt: bolt_component,
  bolt_filled: bolt_filled_component,
  boxplot: boxplot_component,
  breakout: breakout_component,
  broken_link: broken_link_component,
  bubble: bubble_component,
  burger: burger_component,
  cake: cake_component,
  calendar: calendar_component,
  camera: camera_component,
  chart_layout_default: chart_layout_default_component,
  chart_layout_stack: chart_layout_stack_component,
  check: check_component,
  check_filled: check_filled_component,
  code_block: code_block_component,
  chevrondown: chevrondown_component,
  chevronleft: chevronleft_component,
  chevronright: chevronright_component,
  chevronup: chevronup_component,
  click: click_component,
  clipboard: clipboard_component,
  clock: clock_component,
  clone: clone_component,
  close: close_component,
  cloud: cloud_component,
  cloud_12: cloud_12_component,
  cloud_filled: cloud_filled_component,
  compare: compare_component,
  combine: combine_component,
  company: company_component,
  comment: comment_component,
  connections: connections_component,
  contract: contract_component,
  copy: copy_component,
  corner_down_right: corner_down_right_component,
  corner_up_right: corner_up_right_component,
  currency: currency_component,
  curved: curved_component,
  database: database_component,
  database_routing: database_routing_component,
  dependencies: dependencies_component,
  dependent: dependent_component,
  data_studio: data_studio_component,
  dash: dash_component,
  dashboard: dashboard_component,
  curve: curve_component,
  document: document_component,
  download: download_component,
  dyno: dyno_component,
  edit_document: edit_document_component,
  edit_document_outlined: edit_document_outlined_component,
  ellipsis: ellipsis_component,
  embed: embed_component,
  empty: empty_component,
  enter_or_return: enter_or_return_component,
  event: event_component,
  exit: exit_component,
  expand: expand_component,
  expand_arrow: expand_arrow_component,
  extract: extract_component,
  eye: eye_component,
  eye_crossed_out: eye_crossed_out_component,
  eye_outline: eye_outline_component,
  factory: factory_component,
  field: field_component,
  fields: fields_component,
  filter: filter_component,
  filter_plus: filter_plus_component,
  find_replace: find_replace_component,
  bug: bug_component,
  format_code: format_code_component,
  formula: formula_component,
  function: function_component,
  funnel: funnel_component,
  funnel_outline: funnel_outline_component,
  folder: folder_component,
  folder_database: folder_database_component,
  folder_filled: folder_filled_component,
  gauge: gauge_component,
  gear: gear_component,
  gear_settings_filled: gear_settings_filled_component,
  gem: gem_component,
  ghost: ghost_component,
  git_branch: git_branch_component,
  globe: globe_component,
  glossary: glossary_component,
  grabber: grabber_component,
  grid: grid_component,
  grid_2x2: grid_2x2_component,
  grid_bordered: grid_bordered_component,
  group: group_component,
  google: google_component,
  google_drive: google_drive_component,
  google_sheet: google_sheet_component,
  history: history_component,
  home: home_component,
  horizontal_bar: horizontal_bar_component,
  hourglass: hourglass_component,
  info: info_component,
  info_outline: info_outline_component,
  insight: insight_component,
  int: int_component,
  io: io_component,
  join_full_outer: join_full_outer_component,
  join_inner: join_inner_component,
  join_left_outer: join_left_outer_component,
  join_right_outer: join_right_outer_component,
  index: index_component,
  key: key_component,
  label: label_component,
  layout_grid: layout_grid_component,
  ldap: ldap_component,
  learn: learn_component,
  lightbulb: lightbulb_component,
  link: link_component,
  line: line_component,
  lines: lines_component,
  lineandbar: lineandbar_component,
  line_style_dashed: line_style_dashed_component,
  line_style_dotted: line_style_dotted_component,
  line_style_solid: line_style_solid_component,
  list: list_component,
  location: location_component,
  lock: lock_component,
  lock_filled: lock_filled_component,
  mail: mail_component,
  mail_at: mail_at_component,
  mail_filled: mail_filled_component,
  map: map_component,
  mcp: mcp_component,
  medallion: medallion_component,
  message_circle: message_circle_component,
  metabot: metabot_component,
  metabot_sad: metabot_sad_component,
  metric: metric_component,
  mode: mode_component,
  model: model_component,
  model_with_badge: model_with_badge_component,
  moon: moon_component,
  move: move_component,
  move_card: move_card_component,
  network: network_component,
  new_folder: new_folder_component,
  note: note_component,
  note_12: note_12_component,
  notebook: notebook_component,
  number: number_component,
  package: package_component,
  palette: palette_component,
  pause: pause_component,
  pencil: pencil_component,
  pencil_lines: pencil_lines_component,
  permissions_limited: permissions_limited_component,
  person: person_component,
  pie: pie_component,
  pie_slice: pie_slice_component,
  pin: pin_component,
  pinmap: pinmap_component,
  pivot_table: pivot_table_component,
  play: play_component,
  play_outlined: play_outlined_component,
  popover: popover_component,
  popular: popular_component,
  progress: progress_component,
  embed_interactive: embed_interactive_component,
  embed_modular: embed_modular_component,
  embed_static: embed_static_component,
  publish: publish_component,
  published: published_component,
  pulse: pulse_component,
  receipt: receipt_component,
  recents: recents_component,
  revert: revert_component,
  schema: schema_component,
  sankey: sankey_component,
  settings: settings_component,
  share: share_component,
  sort: sort_component,
  sort_arrows: sort_arrows_component,
  split: split_component,
  sql: sql_component,
  subscription: subscription_component,
  straight: straight_component,
  stepped: stepped_component,
  sticky_note: sticky_note_component,
  sum: sum_component,
  sync: sync_component,
  synced_collection: synced_collection_component,
  question: question_component,
  quote: quote_component,
  return: return_component,
  redo: redo_component,
  reference: reference_component,
  refresh: refresh_component,
  refresh_downstream: refresh_downstream_component,
  rename: rename_component,
  repository: repository_component,
  rocket: rocket_component,
  ruler: ruler_component,
  search: search_component,
  search_check: search_check_component,
  section: section_component,
  segment: segment_component,
  send: send_component,
  shield: shield_component,
  shield_outline: shield_outline_component,
  shield_stroke: shield_stroke_component,
  sidebar_closed: sidebar_closed_component,
  sidebar_open: sidebar_open_component,
  slack: slack_component,
  slack_colorized: slack_colorized_component,
  sliders: sliders_component,
  smartscalar: smartscalar_component,
  smile: smile_component,
  snail: snail_component,
  snippet: snippet_component,
  sparkles: sparkles_component,
  star_filled: star_filled_component,
  star: star_component,
  stop: stop_component,
  store: store_component,
  string: string_component,
  sun: sun_component,
  "t-shirt": t_shirt_component,
  tab: tab_component,
  // for database tables
  table: table_component,
  // for questions with table visualizations
  table2: table2_component,
  table_index: table_index_component,
  telescope: telescope_component,
  text_bold: text_bold_component,
  text_italic: text_italic_component,
  text_strike: text_strike_component,
  thumbs_down: thumbs_down_component,
  thumbs_up: thumbs_up_component,
  time_history: time_history_component,
  transform: transform_component,
  trash: trash_component,
  trash_filled: trash_filled_component,
  treemap: treemap_component,
  trend_down: trend_down_component,
  trend_flat: trend_flat_component,
  trend_up: trend_up_component,
  triangle_left: triangle_left_component,
  triangle_right: triangle_right_component,
  unarchive: unarchive_component,
  undo: undo_component,
  unknown: unknown_component,
  unpin: unpin_component,
  unpublish: unpublish_component,
  unreferenced: unreferenced_component,
  unsubscribe: unsubscribe_component,
  upload: upload_component,
  variable: variable_component,
  verified: verified_component,
  octagon_alert: octagon_alert_component,
  official_collection: official_collection_component,
  open_folder: open_folder_component,
  ordered_list: ordered_list_component,
  verified_filled: verified_filled_component,
  verified_round: verified_round_component,
  view_archive: view_archive_component,
  warning: warning_component,
  warning_round: warning_round_component,
  warning_round_filled: warning_round_filled_component,
  warning_triangle_filled: warning_triangle_filled_component,
  waterfall: waterfall_component,
  webhook: webhook_component,
  "10k": ten_thousand_component,
  "1m": one_million_component,
  zap: zap_component,
  zoom_in: zoom_in_component,
  zoom_out: zoom_out_component,
  scalar: number_component,
  external: share_component,
  collection: folder_component,
  collection2: collection2_component,
  beaker: formula_component,
  test_tube: test_tube_component,
  eye_filled: eye_component,
};

// Unjustified type cast. FIXME
export const iconNames = Object.keys(Icons) as unknown as IconName[];

export const isValidIconName = (name: unknown): name is IconName =>
  // Unjustified type cast. FIXME
  iconNames.includes(name as IconName);
